module.exports = __webpack_public_path__ + "static/media/01A.cc931a3e.png";